// extracted by mini-css-extract-plugin
export default {"parent":"DeleteProduct_parent__vXK1r","child":"DeleteProduct_child__g0ElR","name":"DeleteProduct_name__ETMnd","headings":"DeleteProduct_headings__Lo59o"};